import { PlanName } from 'base/accounts_service';
import { mount } from 'base/ui/overlay';
import { currentUrl } from 'blocks/current_url';
import {
  PLAN_UPGRADED_SEARCH_PARAM,
  UpgradeThankYouDialog,
} from 'blocks/manage_account/manage_plan';
import { makeObservable, observable, reaction } from 'mobx';
import React from 'react';

class ConsumeSearchParamStore {
  @observable searchParam: string | undefined;

  constructor(key: string) {
    makeObservable(this);
    reaction(
      () => currentUrl.searchParams.get(key),
      (newValue) => {
        if (newValue) {
          this.searchParam = newValue || undefined;
          // Remove the search param from the URL after consuming it
          const url = new URL(window.location.href);
          url.searchParams.delete(key);
          window.history.replaceState({}, '', url);
        }
      },
      { fireImmediately: true },
    );
  }

  clear = () => {
    this.searchParam = undefined;
  };
}

export function installUpgradeSuccessDialog() {
  const store = new ConsumeSearchParamStore(PLAN_UPGRADED_SEARCH_PARAM);
  reaction(
    () => store.searchParam,
    (planKey) => {
      const planName = planKey?.startsWith('starter')
        ? PlanName.STARTER
        : planKey?.startsWith('pro')
        ? PlanName.PRO
        : planKey?.startsWith('team')
        ? PlanName.TEAM
        : null;

      if (planName) {
        const closeDialog = mount(
          <UpgradeThankYouDialog
            onClose={() => {
              store.clear();
              closeDialog();
            }}
            planName={planName}
          />,
        );
      }
    },
    { fireImmediately: true },
  );
}
